import { Component, OnInit } from '@angular/core';
import { CoreConfigService } from '@core/services/config.service';
import { LandingService } from '../landing.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-us-image',
  templateUrl: './us-image.component.html',
  styleUrls: ['./us-image.component.scss']
})
export class UsImageComponent implements OnInit {
  config;
  url = environment.URL_AWS;
  constructor(
    private _LandingService: LandingService,
    private _coreConfigService: CoreConfigService,) {
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        menu: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        customizer: false,
        enableLocalStorage: false
      }
    };

    var host = window.location.host
    const domain = host.split('.')[1];
    let data;
    if (domain == 'in-mo' || domain == 'inmoapp') {
      data = {
        domain: host.split('.')[0],
      }
    } else {
      data = {
        domain: environment.DOMAIN
      }
    }
    this._LandingService.getConfig(data).then(
      (data: any) => {
        console.log(data);
        this.config = data;
      }, (error: any) => {
        console.log(error);
      }
    );
  }

  ngOnInit(): void {
  }

}
